<script>
  import DropDown from '../components/DropDown.svelte';
  import GridSearch from '../components/GridSearch.svelte';
  import ProfileImg from '../components/ProfileImage.svelte';
  import NavLink from '../components/NavLink.svelte';
  import DataTable from '../components/DataTable/DataTable.svelte';
  import UserProfileModal from '../components/UserProfileModal.svelte';
  let objUserProfileModal;
  import { masterData, getMasterData } from '../stores/masterData.js';
  import { client } from 'root/api/index.js';
  import { onDestroy, onMount, getContext } from 'svelte';
  import {
    configItem,
    getHashUrlParam,
    downloadCsvFile,
    compareArray,
    cloneArray,
  } from '../components/Helper';
  import { navigate } from 'svelte-routing';
  import { getUserInfo } from '../stores/auth';
  import { compareObjs } from '@fullcalendar/common';
  const showDialog = getContext('showDialog');
  let roles = [];
  let getData = (queries) => {
    return client.userList(50, 1, {
      ...queries,
      ...extraFilter,
    });
  };

  let datatableRef;
  let scrollRef;
  let allColumns = [
    { key: 'firstName', label: '', sortable: false },
    { key: 'firstName', label: 'NAME', sortable: true },
    { key: 'email', label: 'Email', sortable: true },
    { key: 'roleName', label: 'role', sortable: true },
    // { key: "mobile", label: "mobile", sortable: false },
    { key: 'units', label: 'Business Units', sortable: true },
    { key: 'active', label: 'Status', sortable: true },
    { key: 'action', label: 'Action', sortable: false },
  ];

  let columns = [...allColumns];

  let defaultFilter = {
    units: [],
    searchKeyword: '',
    roleId: '',
    active: '',
  };
  let extraFilter = { ...defaultFilter };

  let searchTimeout;
  let firstTimeLoad = true;
  let filterData = () => {
    if (searchTimeout != undefined) {
      clearTimeout(searchTimeout);
    }
    searchTimeout = setTimeout(() => {
      if (datatableRef != undefined) {
        if (firstTimeLoad) {
          firstTimeLoad = false;
          return false;
        }
        datatableRef.initializeState();
      }
    }, 250);
  };

  $: extraFilter && filterData();

  const downloadCsv = () => {
    client
      .userListExport({
        ...extraFilter,
      })
      .then(async (result) => {
        downloadCsvFile(result, 'users.csv');
      });
  };

  function onItemSelect(event) {
    if (event.detail.id != undefined) {
      extraFilter.roleId = event.detail.id;
    } else {
      extraFilter.roleId = '';
    }
  }
  let userRolesIndex = null;
  let userRoleId = null;
  let businessUnits = [];
  let legacyCompanyType = [];

  let associatedRegions = [];
  let deliveryVerticals = [];

  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        roles = getMasterData().roles;
        userRolesIndex = getMasterData().userRoleId;
        userRoleId = getUserInfo().roleId;
        businessUnits = cloneArray(getMasterData().units);

        if (userRolesIndex.manager == userRoleId) {
          let columns1 = allColumns.filter((item) => item.key !== 'action');
          columns = columns1.filter((item) => item.key !== 'active');
        }
        let userRoles = getMasterData().userRoleId;
        showImportButton = userRoles.unit_admin == userRoleId || userRoles.admin == userRoleId;
        legacyCompanyType = getMasterData().legacyCompanyTypeLabel;
        deliveryVerticals = getMasterData().deliveryVerticals;
        associatedRegions = getMasterData().associatedRegions;
      }
    });
  });

  const checkUrl = () => {
    setTimeout(() => {
      let params = getHashUrlParam();
      if (params.action != undefined) {
        if (params.action == 'editUser') {
          navigate(`/user/edit/` + params.userId);
        }
        window.location.hash = '';
      }
    }, 1000);
  };

  onDestroy(() => {
    unsubscribe();
  });
  onMount(() => {
    checkUrl();
  });
  let showImportButton = false;
</script>

<div class="d-flex h-100 w-100 p-3 flex-column">
  <div class="block-header mb-2">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="page-title">Users</h2>
      </div>
      <div class="col-md-6 text-end">
        {#if showImportButton}
          <button
            on:click={() => navigate('/user/import')}
            type="button"
            class="mb-0 px-3 font-size-13 btn btn-primary font-size-13 shadow-none px-3"
          >
            <img
              class="me-2 icon-16"
              src="./images/import-icon.svg"
              alt=""
            />User Import</button
          >
        {/if}
      </div>
    </div>
  </div>
  <div class="page-content card-content bg-white">
    <div class="d-flex flex-column h-100">
      <div class="filter-content top-menu-filter">
        <div class="d-flex flex-row justify-content-between">
          <div class="w-50">
            <div class="d-flex flex-row">
              {#if userRoleId != null && userRolesIndex.manager != userRoleId}
                <NavLink
                  Style="mb-0 px-3 font-size-13 add-task-btn text-white d-flex
					 align-items-center btn-add-user"
                  to="/user/add"
                >
                  + &nbsp;&nbsp;Add User
                </NavLink>
              {/if}

              <DropDown
                checkbox={false}
                active={true}
                title="Select Role"
                option={roles}
                Style="select-block ms-1"
                selectable={true}
                titleChanged={true}
                on:onSelect={onItemSelect}
              />
              <DropDown
                checkbox={false}
                active={true}
                title="Select Status"
                option={[
                  {
                    id: '1',
                    name: 'Active',
                  },
                  {
                    id: '0',
                    name: 'Inactive',
                  },
                ]}
                Style="select-block ms-1"
                selectable={true}
                titleChanged={true}
                on:onSelect={(event) => {
                  extraFilter.active = event.detail.id ? event.detail.id : '';
                }}
              />

              <DropDown
                checkbox={true}
                active={true}
                title="Business Unit"
                labelFields="name"
                keyFields="id"
                option={businessUnits}
                checkedFields="checked"
                Style="select-block ms-1"
                removeIcon={true}
                on:onClear={(event) => {
                  extraFilter.units = [];
                }}
                on:onSelect={(event) => {
                  extraFilter.units = [...event.detail];
                }}
              />
              <DropDown
                title="Legacy Company"
                titleChanged={true}
                option={legacyCompanyType}
                Style="select-block ms-1"
                on:onSelect={(event) => {
                  extraFilter.legacyCompanyType = event.detail.id;
                }}
              />
              <DropDown
                title="Associated Region"
                titleChanged={true}
                option={associatedRegions}
                Style="select-block ms-1"
                on:onSelect={(event) => {
                  extraFilter.associatedRegionId = event.detail.id;
                }}
              />
              <DropDown
                title="Delivery Verticals"
                titleChanged={true}
                option={deliveryVerticals}
                Style="select-block ms-1"
                on:onSelect={(event) => {
                  extraFilter.deliveryVerticalId = event.detail.id;
                }}
              />
            </div>
          </div>
          <GridSearch
            bind:value={extraFilter.searchKeyword}
            btnExport={true}
            placeholder="Search"
            onAction={(params) => {
              if (params == 'export') {
                downloadCsv();
              }
              if (params == 'delete') {
                alert('delete');
              }
            }}
          />
        </div>
      </div>
      <div class="page-content card border-0 p-3">
        <div
          class="ibox-content page-content"
          bind:this={scrollRef}
        >
          <DataTable
            bind:this={datatableRef}
            columns={columns}
            scrollRef={scrollRef}
            getData={getData}
            let:row
          >
            <td width="38">
              <ProfileImg
                size={30}
                photoUrl={row.photoUrl}
                firstName={row.firstName}
                lastName={row.lastname}
                className="d-inline-block align-middle"
              />
            </td>
            <td width="200">
              <button
                type="button"
                class="btn btn-link text-start mb-0 shadow-none bg-transparent border-0 font-size-12 p-0 blue-color text-break"
                on:click={() => {
                  if (userRoleId != null && userRolesIndex.manager != userRoleId && row.isEdit) {
                    objUserProfileModal.show(row.id);
                  }
                }}
              >
                <span class="user-name d-block">{row.firstName} {row.lastname}</span>
              </button>
            </td>
            <td width="350"><span class="text-break">{row.email}</span></td>
            <td width="200"><span class="text-break">{row.roleName}</span></td>
            <!-- <td width="200"><span class="text-break">{row.mobile}</span></td> -->
            <td width="350"><span class="text-break">{row.units}</span></td>
            {#if userRoleId != null && userRolesIndex.manager != userRoleId}
              <td width="110">
                <div class="form-check form-switch status-switch-block">
                  <input
                    id={row.id}
                    checked={row.active === 1}
                    class="form-check-input shadow-none"
                    type="checkbox"
                    on:change={(event) => {
                      showDialog({
                        type: 'confirm',
                        title: '',
                        message: 'Are you sure ?',
                        okFunc: () => {
                          client
                            .userUpdateStatus({
                              id: row.id,
                            })
                            .then((result) => {
                              row.active = event.target.checked
                                ? configItem.status.active
                                : configItem.status.inactive;
                            })
                            .catch((error) => {
                              event.target.checked = row.active === configItem.status.active;
                              showDialog({
                                message: error.message,
                              });
                            });
                        },
                        cancelFunc: () => {
                          event.target.checked = row.active === configItem.status.active;
                        },
                      });
                    }}
                  />
                </div>
              </td>
            {/if}

            {#if userRoleId != null && userRolesIndex.manager != userRoleId && row.isEdit}
              <td width="40">
                <button
                  class="btn bg-transparent shadow-none border-0 p-0 m-0 me-2"
                  on:click={() => navigate(`/user/edit/${row.id}`)}
                >
                  <img
                    class="icon-16"
                    alt=""
                    src="/images/pencil-gray.svg"
                  />
                </button>
              </td>
            {/if}
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</div>

<UserProfileModal bind:this={objUserProfileModal} />

<style lang="scss">
  :global(.btn-add-user) {
    height: 35px;
  }
</style>
